import { ChakraProvider as CoreChakraProvider } from '@chakra-ui/react';
import type { ChakraProviderProps as CoreChakraProviderProps } from '@chakra-ui/react';

import { PreferredDateFormat } from '@frontend/api';
import { TemporalSettingsProvider } from '@frontend/utils';

import { theme } from './theme';

export type ChakraProviderProps = Pick<
  CoreChakraProviderProps,
  'children' | 'resetCSS'
> & {
  preferredDateFormat: PreferredDateFormat;
};

export const ChakraProvider = ({
  children,
  preferredDateFormat,
  resetCSS = false,
}: ChakraProviderProps) => (
  <CoreChakraProvider theme={theme} resetCSS={resetCSS}>
    <TemporalSettingsProvider preferredDateFormat={preferredDateFormat}>
      {children}
    </TemporalSettingsProvider>
  </CoreChakraProvider>
);
